<template>
	<div class="shopCart">
		<myheader></myheader>
		<div class="smain">
			<div class="main">
				<div class="null" v-if="clist.length == 0">
					<img src="../assets/image/nullbg.png">
					<div class="p">这里购物车是空的，赶紧去加购吧～</div>
					<span @click="$router.push('/home')">去购物</span>
				</div>

				<div class="listbox" v-if="clist.length>0">
					<el-table :data="clist" style="width: 100%" stripe header-cell-class-name="custom-class"
						height="calc(100% - 50px)" @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="55" fixed="left" align="center" header-align="center" :selectable="onselectable">
						</el-table-column>
						<el-table-column prop="product_style_number" label="款号" align="center" width="100px"
							header-align="center" fixed="left">
						</el-table-column>
						<el-table-column prop="" label="图片" align="center" header-align="center" width="84px"
							fixed="left">
							<template slot-scope="scope">
								<img class="img" :src="onimgarr(scope.row.product_pic)[0]" v-if="scope.row.product_pic">
							</template>
						</el-table-column>
						<el-table-column prop="product_brand" label="品牌" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="shop_name" label="渠道" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="product_size" label="尺码" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="product_season" label="季度" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="product_stock" label="库存" align="center" header-align="center">
						</el-table-column>
						<el-table-column label="数量" align="center" header-align="center" width="160px">
							<template slot-scope="scope">
								<el-input-number v-model="scope.row.num" :min="0" :max="scope.row.product_stock"
									size="small" @change="onnumChange($event,scope.row.id)">
								</el-input-number>
							</template>
						</el-table-column>
						<el-table-column prop="product_price" label="原价" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="product_true_discount" label="折扣" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="product_true_price" label="实际单价" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="product_scale" label="重量" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="product_true_total_price" label="实际金额" align="center"
							header-align="center" width="100px">
						</el-table-column>
						<el-table-column label="操作" align="center" header-align="center" fixed="right">
							<template slot-scope="scope">
								<div class="operation_i">
									<span @click="ondelete(scope.row.id,1)">删除</span>
								</div>
							</template>
						</el-table-column>
					</el-table>

					<div class="btnbox" v-if="selectlist.length>0">
						<div>已选择 <span>{{selectlist.length}}</span> 条</div>
						<el-button type="primary" size="small" @click="ondelete('',2)">删除</el-button>
						<el-button type="primary" size="small" @click="onpayment">确认订购</el-button>
					</div>

					<!-- <div class="pagediv">
						<el-pagination background layout="prev, pager, next" :current-page.sync="page"
							:page-size="pageSize" :total="total" v-if="total>0" @current-change="handleCurrentChange">
						</el-pagination>
					</div> -->
				</div>

				<el-dialog title="订购单" :visible.sync="paymentVisible" width="90%" :before-close="onclose"
					:close-on-click-modal="false">
					<el-table :data="selectlist" style="width: 100%" stripe header-cell-class-name="custom-class"
						border>
						<el-table-column prop="product_style_number" label="款号" align="center" min-width="90px"
							header-align="center" fixed="left">
						</el-table-column>
						<el-table-column prop="" label="图片" align="center" header-align="center" min-width="84px"
							fixed="left">
							<template slot-scope="scope">
								<img class="img" :src="onimgarr(scope.row.product_pic)[0]" v-if="scope.row.product_pic">
							</template>
						</el-table-column>
						<el-table-column prop="product_brand" label="品牌" align="center" header-align="center"
							min-width="70px">
						</el-table-column>
						<el-table-column prop="shop_name" label="渠道" align="center" header-align="center"
							min-width="70px">
						</el-table-column>
						<el-table-column prop="product_size" label="尺码" align="center" header-align="center"
							min-width="60px">
						</el-table-column>
						<el-table-column prop="product_season" label="季度" align="center" header-align="center"
							min-width="60px">
						</el-table-column>
						<el-table-column prop="product_stock" label="库存" align="center" header-align="center"
							min-width="60px">
						</el-table-column>
						<el-table-column prop="num" label="数量" align="center" header-align="center" min-width="50px">
						</el-table-column>
						<el-table-column prop="product_price" label="原价" align="center" header-align="center"
							min-width="60px">
						</el-table-column>
						<el-table-column prop="product_true_discount" label="折扣" align="center" header-align="center"
							min-width="60px">
						</el-table-column>
						<el-table-column prop="product_true_price" label="实际单价" align="center" header-align="center"
							min-width="60px">
						</el-table-column>
						<el-table-column prop="product_scale" label="重量" align="center" header-align="center"
							min-width="60px">
						</el-table-column>
						<el-table-column prop="product_true_total_price" label="实际金额" align="center"
							header-align="center" min-width="60px" fixed="right">
						</el-table-column>
					</el-table>
					<div class="statistics">
						共计:{{js}}件商品 大概重量:{{zl}}(kg) 商品总价: {{zj}}元
					</div>
					<div class="form_kd">
						<div class="ohead">
							收货人信息
						</div>
						<div class="forms">
							<div class="form">
								<el-form :model="ruleForm" :rules="rules" ref="form" label-width="100px"
									class="demo-ruleForm">
									<el-form-item label="常用收货地址" class="item1">
										<el-select v-model="cydz" placeholder="请选择" @visible-change="oncydz"
											@change="onfz">
											<el-option v-for="(v,k) in cydzarr" :label="onlabel(v)" :key="k"
												:value="v.id"></el-option>
										</el-select>
										<span @click="onaddress()">收货人地址管理</span>
									</el-form-item>
									<el-form-item label="收货人姓名" prop="recv_name">
										<el-input v-model="ruleForm.recv_name" placeholder="请填写收货人姓名"></el-input>
									</el-form-item>
									<el-form-item label="所属地区" prop="areaData">
										<el-cascader :props="props" v-model="ruleForm.areaData" :options="regionData"
											style="width: 100%;"></el-cascader>
									</el-form-item>
									<el-form-item label="详细地址" prop="recv_address">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}"
											placeholder="请填写详细地址" v-model="ruleForm.recv_address">
										</el-input>
									</el-form-item>
									<el-form-item label="收货人电话" prop="recv_mobile">
										<el-input v-model="ruleForm.recv_mobile" placeholder="请填写收货人电话"></el-input>
										<div style="width: 100%;display: flex;justify-content: end;margin-top: 10px;"
											v-if="btnshow()">
											<el-button type="primary" size="small" @click="onsave()">保存该收货人地址
											</el-button>
										</div>
									</el-form-item>
									<el-form-item label="备注">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder=""
											v-model="ruleForm.remark">
										</el-input>
									</el-form-item>
									<el-form-item label="订单来源" prop="cfrom">
										<el-radio-group v-model="ruleForm.cfrom">
											<el-radio :label="v.id" v-for="(v,k) in appdata.list.order_cfrom" :key="k">
												{{v.name}}
											</el-radio>
										</el-radio-group>
									</el-form-item>
									<el-form-item label="客户单号">
										<el-input v-model="ruleForm.out_trade_no" placeholder=""></el-input>
										<div class="ts" v-if="ruleForm.cfrom == 3 || ruleForm.cfrom == 5">
											注意:京东、抖店订单，必须填写客户单号（京东、抖店订单号）！否则不能出运单</div>
									</el-form-item>
								</el-form>
							</div>
							<div class="form">
								<el-form label-width="100px" class="demo-ruleForm">
									<el-form-item label="地址解析">
										<el-input type="textarea" :autosize="{ minRows: 4, maxRows: 7}" placeholder=""
											v-model="jxtext">
										</el-input>
										<div style="width: 100%;display: flex;justify-content: end;margin-top: 10px;">
											<el-button type="primary" size="small" @click="onformat()">地址解析</el-button>
										</div>
									</el-form-item>
								</el-form>
							</div>
						</div>
					</div>
					
					<div class="kuaidi" v-if="kuaidi && kuaidi.length>0">
						<div class="ohead">
							快递信息
						</div>
						<div class="item" v-for="(v,k) in kuaidi">
							<div class="shopname">{{v.shop_name}}</div>
							<div class="kdxx">
								<el-table :data="kuaidi[k].delivery_list" style="width: 100%" border>
									<el-table-column label="物流" header-align="center">
										<template slot-scope="scope">
											<el-radio v-model="kuaidi[k].delivery_id" :label="scope.row.id">
												{{scope.row.delivery_name}}
											</el-radio>
										</template>
									</el-table-column>
									<el-table-column prop="total_scale" label="运费" align="center" header-align="center">
									</el-table-column>
									<el-table-column prop="prev_send_delivery_date" label="预计发货日期" width="180px"
										align="center" header-align="center">
									</el-table-column>
									<el-table-column label="多仓发货" align="center" header-align="center" width="80px">
										<template slot-scope="scope">
											<img class="simg" src="../assets/image/dancang.jpg" :title="alt"
												v-if="scope.row.shop_multi_delivery_switch == 0">
											<img class="simg" src="../assets/image/duocang.jpg" :title="alt"
												v-if="scope.row.shop_multi_delivery_switch == 1">
										</template>
									</el-table-column>
								</el-table>
							</div>
						</div>
					</div>

					<div slot="footer" class="dialog-footer">
						<el-button type="primary" @click="onsub()">确定</el-button>
						<el-button @click="onclose">取消</el-button>
					</div>
				</el-dialog>

				<el-dialog title="结算单" :visible.sync="jsVisible" width="90%" :before-close="onclose1"
					:close-on-click-modal="false">
					<div v-for="(v,k) in jsobj.list" :key="k" style="margin-bottom: 14px">
						<div class="htable">
							<div class="lh">订单编号</div>
							<div class="rv">
								{{v.trade_no}}
							</div>
						</div>
						<el-table :data="v.item" style="width: 100%" stripe header-cell-class-name="custom-class" border>
							<el-table-column prop="product_style_number" label="款号" align="center" min-width="90px"
								header-align="center" fixed="left">
							</el-table-column>
							<el-table-column prop="" label="图片" align="center" header-align="center" min-width="84px"
								fixed="left">
								<template slot-scope="scope">
									<img class="img" :src="onimgarr(scope.row.product_pic)[0]"
										v-if="scope.row.product_pic">
								</template>
							</el-table-column>
							<el-table-column prop="product_brand" label="品牌" align="center" header-align="center"
								min-width="70px">
							</el-table-column>
							<el-table-column prop="shop_name" label="渠道" align="center" header-align="center"
								min-width="70px">
							</el-table-column>
							<el-table-column prop="product_size" label="尺码" align="center" header-align="center"
								min-width="60px">
							</el-table-column>
							<el-table-column prop="product_season" label="季度" align="center" header-align="center"
								min-width="60px">
							</el-table-column>
							<el-table-column prop="product_stock" label="库存" align="center" header-align="center"
								min-width="60px">
							</el-table-column>
							<el-table-column prop="num" label="数量" align="center" header-align="center"
								min-width="50px">
							</el-table-column>
							<el-table-column prop="product_price" label="原价" align="center" header-align="center"
								min-width="60px">
							</el-table-column>
							<el-table-column prop="product_true_discount" label="折扣" align="center"
								header-align="center" min-width="60px">
							</el-table-column>
							<el-table-column prop="product_true_price" label="实际单价" align="center" header-align="center"
								min-width="60px">
							</el-table-column>
							<el-table-column prop="product_scale" label="重量" align="center" header-align="center"
								min-width="60px">
							</el-table-column>
							<el-table-column prop="product_true_total_price" label="实际金额" align="center"
								header-align="center" min-width="60px" fixed="right">
							</el-table-column>
						</el-table>
						<div class="statistics">
							{{v.memo}}
						</div>
					</div>
					
					<div class="feediv">
						<p>所有订单应付总金额: {{jsobj.total_fee_all}}元</p>
						<p>{{appdata.myinfo.username}}, 您的可支付余额: {{appdata.myinfo.money}}元</p>
					</div>
					
					<div class="item">
						<div class="ohead">
							收货人信息
						</div>
						<div class="itable">
							<div class="qdtable">
								<div class="lh">收货人姓名</div>
								<div class="rv">
									{{jsobj.recv_name}}
								</div>
							</div>
							<div class="qdtable">
								<div class="lh">所属地区</div>
								<div class="rv">
									{{jsobj.recv_province_str}}{{jsobj.recv_city_str}}{{jsobj.recv_area_str}}
								</div>
							</div>
							<div class="qdtable">
								<div class="lh">详细地址</div>
								<div class="rv">
									{{jsobj.recv_province_str}} {{jsobj.recv_city_str}} {{jsobj.recv_area_str}} {{jsobj.recv_address}}
								</div>
							</div>
							<div class="qdtable">
								<div class="lh">手机号</div>
								<div class="rv">
									{{jsobj.recv_mobile}}
								</div>
							</div>
							<div class="qdtable">
								<div class="lh">客户单号</div>
									{{jsobj.out_trade_no}}
								<div class="rv">
								</div>
							</div>
							<div class="qdtable">
								<div class="lh">备注</div>
								<div class="rv">
									{{jsobj.remark}}
								</div>
							</div>
						</div>
					</div>
					
					<div slot="footer" class="dialog-footer">
						<el-button type="primary" @click="cartorder(jsobj.key,1)">确定订购</el-button>
						<el-button type="primary" @click="cartorder(jsobj.key,2)">确定订购并扣款</el-button>
						<el-button @click="onclose1">返回</el-button>
					</div>
				</el-dialog>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		regionData
	} from 'element-china-area-data'
	export default {
		name: 'ShopCart',
		data() {
			return {
				clist: [],
				selectlist: [],
				js: 0,
				zl: 0,
				zj: 0,
				page: 1,
				pageSize: 100,
				total: 0,
				paymentVisible: false,
				ruleForm: {
					cfrom: "",
					recv_name: "",
					recv_province: "",
					recv_city: "",
					recv_area: "",
					recv_address: "",
					recv_mobile: "",
					out_trade_no: "",
					areaData: [],
				},

				rules: {
					recv_name: [{
						required: true,
						message: '请填写收货人姓名',
						trigger: 'blur'
					}],

					areaData: [{
						required: true,
						message: '请选择所属地区',
						trigger: 'change'
					}],

					recv_city: [{
						required: true,
						message: '请选择城市',
						trigger: 'change'
					}],

					recv_area: [{
						required: true,
						message: '请选择市区',
						trigger: 'change'
					}],

					recv_mobile: [{
						required: true,
						message: '请填写收货人电话',
						trigger: 'blur'
					}],

					recv_address: [{
						required: true,
						message: '请填写详细地址',
						trigger: 'blur'
					}],

					cfrom: [{
						required: true,
						message: '请选择订单来源',
						trigger: 'change'
					}]
				},

				regionData: [],
				props: {
					value: 'label',
					label: 'label',
					children: 'children'
				},
				kuaidi: [],
				cydz: "",
				cydzarr: [],
				fz: "",
				jxtext: "",
				jsVisible: false,
				jsobj: {},
				alt: "选择省份，显示该省份的实际运费标准,“单”表示本渠道单仓发货；“多”表示多仓发货，多件的订单可能分多仓发货，尤其是需要发顺丰到付的！“按件”表示渠道的运费计算方式（因多仓发货，按件收费，若下多件，第1件，按首重付费，第2件开始按续重收费），请注意！"
			}
		},

		mounted() {
			this.onclist();
			this.regionData = regionData;
		},

		inject: ['onimgarr', 'appdata'],

		watch: {
			'ruleForm.areaData': {
				handler(newQuery, oldQuery) {
					if (newQuery.length>0) {
						this.cdlist();
					}
				},
				deep: true, // 确保对象内部属性的变化也能被检测到
				immediate: true // 组件创建时立即执行一次handler
			}
		},

		methods: {
			onclist() {
				var obj = {
					id: "",
					page: this.page,
					limit: this.pageSize
				};

				this.$axios.post('api/user/cart_list', obj).then(res => {
					if (res.data.code == 0) {
						this.clist = res.data.data.list;
						this.total = res.data.data.count;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			handleCurrentChange(val) {
				this.page = val;
				this.onclist();
			},

			onpayment() {
				var js = 0;
				var zl = 0;
				var zj = 0;
				this.selectlist.forEach((v, k) => {
					if (v.num) {
						js = js + Number(v.num);
					}

					if (v.product_true_scale) {
						zl = zl + Number(v.product_true_scale);
					}

					if (v.product_true_total_price) {
						zj = zj + Number(v.product_true_total_price);
					}
				})
				this.js = js;
				this.zl = zl.toFixed(2);
				this.zj = zj.toFixed(2);
				
				if(this.$route.query.trade_no) {
					this.oninfo();
				}else {
					this.paymentVisible = true;
				}
			},

			onclose() {
				this.paymentVisible = false;
				this.ruleForm = {
					cfrom: "",
					recv_name: "",
					recv_province: "",
					recv_city: "",
					recv_area: "",
					recv_address: "",
					recv_mobile: "",
					out_trade_no: "",
					areaData: [],
				};
				this.js = 0;
				this.zl = 0;
				this.zj = 0;
				this.jxtext = "";
				this.kuaidi = [];
				this.cydz = "";
				this.cydzarr = [];
			},

			onsub(n) {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						var obj = {};
						var arr = [];
						obj = JSON.parse(JSON.stringify(this.ruleForm));
						obj.recv_province = obj.areaData[0];
						obj.recv_city = obj.areaData[1];
						obj.recv_area = obj.areaData[2];
						this.kuaidi.forEach((v, k) => {
							var obj1 = {};
							obj1.shop_id = v.shop_id;
							obj1.delivery_id = v.delivery_id;
							arr.push(obj1);
						})
						obj.delivery_config = JSON.stringify(arr);
						obj.ids = this.onids();
						this.$axios.post('api/user/cart_jiesuan', obj).then(res => {
							if (res.data.code == 0) {
								// this.$message.success('下单成功');
								//需要在这里补一个类似订单详情的确认订单页面(提交订单,立即付款,取消)
								// this.cartorder(res.data.data.key);
								this.jsVisible = true;
								this.jsobj = res.data.data;
								// this.onclose();
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			},

			cartorder(key,n) {
				var obj = {
					key: key
				};
				var list = [];
				this.jsobj.list.forEach((v,k)=>{
					list.push(v.trade_no);
				})
				var t = list.join(',');
				this.$axios.post('api/user/cart_build_order', obj).then(res => {
					if (res.data.code == 0) {
						if(n == 1) {
							this.$message.success('订购成功');
							this.$router.push({
								path: '/buyer/order/order',
								query: {}
							})
						} else {
							var obj1 = {
								trade_no: t
							}
							this.$axios.post('api/user/pay_order', obj1).then(res => {
								if (res.data.code == 0) {
									this.$message.success('付款成功');
									this.$router.push({
										path: '/buyer/order/order',
										query: {}
									})
								} else {
									this.$message.error(res.data.message);
								}
							}).catch(err => {
								console.log(err)
							})
						}
						
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onnumChange(num, id) {
				var obj = {
					id: id,
					num: num
				};
				this.$axios.post('api/user/cart_update_num', obj).then(res => {
					if (res.data.code == 0) {
						this.onclist();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			cdlist() {
				var obj = {
					province: this.ruleForm.areaData[0],
					ids: this.onids()
				}

				this.$axios.post('api/user/cart_delivery_list', obj).then(res => {
					if (res.data.code == 0) {
						if (res.data.data && res.data.data.length > 0) {
							this.kuaidi = this.onkuaidi(res.data.data);
						}
					} else {
						this.$message.error(res.data.message);
						this.onclist();
					}
				}).catch(err => {
					console.log(err)
				})

			},

			onkuaidi(data) {
				data.forEach((v, k) => {
					if (v.delivery_list && v.delivery_list.length > 0) {
						this.$set(v, 'delivery_id', v.delivery_list[0] ? v.delivery_list[0].id : 0)
					}
				})
				return data;
			},

			ondelete(id, n) {
				var text = "";
				var ids = "";
				if (n == 1) {
					text = "是否删除该条购物车数据, 是否继续?";
					ids = id;
				}

				if (n == 2) {
					text = "是否删除" + this.selectlist.length + "条购物车数据, 是否继续?";
					ids = this.onids();
				}
				this.$confirm(text, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var obj = {
						ids: ids
					}
					this.$axios.post('api/user/cart_delete', obj).then(res => {
						if (res.data.code == 0) {
							this.$message.success('删除成功');
							this.onclist();
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {});
			},

			handleSelectionChange(val) {
				this.selectlist = val;
			},

			onids() {
				var arr = [];
				this.selectlist.forEach((v, k) => {
					arr.push(v.id);
				})

				return arr.join(',');
			},

			oncydz(val) {
				console.log(val);
				if (val) {
					var obj = {};
					obj.page = 1;
					obj.limit = 10000;
					this.$axios.post('api/user/user_address_list', obj).then(res => {
						if (res.data.code == 0) {
							this.cydzarr = res.data.data.list;
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				}
			},

			onfz(val) {
				if (this.cydzarr.length > 0) {
					this.cydzarr.forEach((v, k) => {
						if (v.id == val) {
							this.ruleForm.recv_name = v.name;
							this.ruleForm.recv_province = v.province;
							this.ruleForm.recv_city = v.city;
							this.ruleForm.recv_area = v.area;
							this.ruleForm.recv_address = v.address;
							this.ruleForm.recv_mobile = v.mobile;
							var arr = [];
							arr.push(v.province);
							arr.push(v.city);
							if (v.area) {
								arr.push(v.area);
							}
							this.ruleForm.areaData = JSON.parse(JSON.stringify(arr));
						}
					})

					this.cydzarr = [];
				}
			},

			onaddress() {
				const route = this.$router.resolve({
					path: '/buyer/address'
				});
				window.open(route.href, '_blank');
			},

			onlabel(v) {
				return v.name + ',' + v.mobile + " " + v.province_str + "/" + v.city_str + "/" + v.area_str + "/" + v
					.address
			},

			btnshow() {
				if (this.ruleForm.recv_name && this.ruleForm.recv_province && this.ruleForm.recv_address && this.ruleForm
					.recv_mobile && this.ruleForm.areaData.length > 0) {
					return true;
				} else {
					return false;
				}

			},

			onsave() {
				var obj = {};
				obj.id = 0;
				obj.name = this.ruleForm.recv_name;
				obj.mobile = this.ruleForm.recv_mobile;
				obj.address = this.ruleForm.recv_address;
				obj.weight = "";
				obj.province = this.ruleForm.areaData[0];
				obj.city = this.ruleForm.areaData[1];
				obj.area = this.ruleForm.areaData[2];
				this.$axios.post('api/user/user_address_save', obj).then(res => {
					if (res.data.code == 0) {
						this.$message.success('操作成功');
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onformat() {
				if (!this.jxtext) {
					this.$message.warning('地址解析不能为空');
					return;
				}
				var obj = {};
				obj.text = this.jxtext;
				this.$axios.post('api/user/address_format', obj).then(res => {
					if (res.data.code == 0) {
						this.$message.success('操作成功');
						var data = res.data.data;
						this.ruleForm.recv_name = data.name;
						this.ruleForm.recv_province = data.province;
						this.ruleForm.recv_city = data.city;
						this.ruleForm.recv_area = data.area;
						this.ruleForm.recv_address = data.address;
						this.ruleForm.recv_mobile = data.mobile;
						var provinces = ['北京市', '天津市', '上海市', '重庆市'];
						if (provinces.includes(this.ruleForm.recv_province)) {
							this.ruleForm.recv_city = "市辖区";
						}
						var arr = [];
						arr.push(this.ruleForm.recv_province);
						arr.push(this.ruleForm.recv_city);
						if (this.ruleForm.recv_area) {
							arr.push(this.ruleForm.recv_area);
						}
						this.ruleForm.areaData = JSON.parse(JSON.stringify(arr));
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onclose1() {
				this.jsobj = {};
				this.jsVisible = false;
			},
			
			oninfo() {
				var obj = {
					trade_no: this.$route.query.trade_no
				}
				
				this.$axios.post('api/user/order_info', obj).then(res => {
					if (res.data.code == 0) {
						console.log(res.data.data.order);
						var data = res.data.data.order;
						this.ruleForm.recv_name = data.recv_name;
						this.ruleForm.recv_province = data.recv_province;
						this.ruleForm.recv_city = data.recv_city;
						this.ruleForm.recv_area = data.recv_area;
						this.ruleForm.recv_address = data.recv_address;
						this.ruleForm.recv_mobile = data.recv_mobile;
						var arr = [];
						arr.push(this.ruleForm.recv_province);
						arr.push(this.ruleForm.recv_city);
						if (this.ruleForm.recv_area) {
							arr.push(this.ruleForm.recv_area);
						}
						this.ruleForm.areaData = JSON.parse(JSON.stringify(arr));
						this.paymentVisible = true;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
				
			},
			
			onselectable(row, index) {
				if(row.product_stock) {
					return true;
				}else {
					return false;
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.smain {
		width: 100%;
		height: calc(100vh - 37px);
		background-color: #fafafa;

		.main {
			height: 100%;
			width: 1200px;
			margin: 0 auto;

			.null {
				width: 100%;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;

				img {
					width: 290px;
				}

				.p {
					margin-top: 20px;
					font-size: 16px;
					color: #999;
				}

				span {
					margin-top: 20px;
					color: #f98a46;
					font-size: 14px;
					cursor: pointer;
				}
			}

			.listbox {
				width: 100%;
				height: 100%;
				background-color: #fff;
				padding: 20px;
				box-sizing: border-box;
			}
		}

		.img {
			width: 60px;
		}
	}

	.kuaidi {
		width: 100%;

		.item {
			width: 100%;
			display: flex;
			margin-bottom: 20px;

			.shopname {
				min-width: 100px;
				width: 100px;
				display: flex;
				align-items: center;
				justify-content: center;
				border: 1px solid #EBEEF5;
			}

			.kdxx {
				width: 100%;
			}
		}
	}

	.ts {
		color: #F65730;
	}

	.btnbox {
		margin-top: 20px;
		display: flex;
		align-items: center;

		div {
			font-size: 14px;
			margin-right: 20px;
		}

		span {
			color: #F65730;
		}
	}

	.form_kd {
		margin-top: 20px;
	}

	.forms {
		width: 100%;
		display: flex;
		margin-top: 20px;
	}

	.form {
		width: 50%;
		padding: 0 10px;
		box-sizing: border-box;

		/deep/ .el-radio {
			margin-bottom: 10px;
		}
	}

	.ohead {
		width: 100%;
		height: 40px;
		font-size: 14px;
		font-weight: bold;
		color: #000;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #EBEEF5;

		span {
			color: #ff4714;
			margin-left: 6px;
		}
	}

	.statistics {
		width: 100%;
		border: 1px solid #EBEEF5;
		border-top: none;
		font-size: 14px;
		padding: 5px;
		box-sizing: border-box;
	}
	
	.htable {
		width: 100%;
		height: 32px;
		border: 1px solid #EBEEF5;
		border-bottom: none;
		font-size: 14px;
		padding: 5px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		.lh {
			width: 100px;
			height: 32px;
			line-height: 32px;
			text-align: center;
			border-right: 1px solid #EBEEF5;
		}
		.rv {
			padding-left: 20px;
		}
	}

	.item1 {
		/deep/ .el-select {
			width: calc(100% - 130px) !important;
		}

		span {
			color: #F65730;
			margin-left: 20px;
			cursor: pointer;
			font-size: 14px;
		}
	}
	
	.feediv {
		width: 100%;
		height: 60px;
		border: 1px solid #EBEEF5;
		padding: 5px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}
	
	.qdtable {
		width: 100%;
		display: flex;
		font-size: 14px;
	
		>div {
			min-height: 40px;
			display: flex;
			align-items: center;
			border-bottom: 1px solid #EBEEF5;
		}
	
		.lh {
			width: 180px;
			min-width: 180px;
			justify-content: center;
			border-right: 1px solid #EBEEF5;
		}
	
		.rv {
			width: 100%;
			padding-left: 10px;
			display: flex;
	
			div {
				width: 50%;
			}
	
			.time {
				padding: 9px;
				border-left: 1px solid #EBEEF5;
	
				p {
					line-height: 20px;
				}
			}
	
		}
	}
	
	.itable {
		border: 1px solid #EBEEF5;
		border-bottom: none;
	}
</style>



// WEBPACK FOOTER //
// src/components/shopCart.vue